// client/src/pages/AuthPage.jsx
import PasswordReset from '../components/PasswordReset';
import Logo from '../styles/logo1.png';

export default function AuthPage() {
  return (
    <div className="app-shell relative min-h-screen overflow-hidden text-slate-100">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[6%] top-[12%] h-44 w-44 rounded-full bg-amber-400/15 blur-3xl" />
        <div className="absolute right-[8%] top-[18%] h-52 w-52 rounded-full bg-teal-300/15 blur-3xl" />
        <div className="absolute inset-x-10 bottom-6 h-[1px] bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </div>

      <main className="relative mx-auto flex min-h-screen w-full max-w-5xl flex-col items-center justify-center px-4 py-12">
        <div className="mb-10 flex flex-col items-center gap-3 text-center">
          <div className="grid h-16 w-16 place-items-center rounded-2xl border border-white/10 bg-white/5 shadow-[0_16px_50px_-20px_rgba(246,196,82,0.7)]">
            <img src={Logo} alt="Arch Intelligence logo" className="h-10 w-10 object-contain opacity-90" />
          </div>
          <div className="glass-chip rounded-full border-white/15 text-[11px] tracking-[0.32em] text-amber-100 shadow-[0_20px_70px_-24px_rgba(246,196,82,0.7)]">
            Arch Intelligence
          </div>
          <p className="max-w-2xl text-sm text-slate-400">
            A calm, glassy workspace for estimating, design, and vendor intelligence.
          </p>
        </div>

        <div className="glass-card w-full border border-white/10 p-6 shadow-[0_24px_90px_-28px_rgba(0,0,0,0.65)]">
          <div className="grid gap-8 lg:grid-cols-[1fr_1.05fr] lg:items-center">
            <div className="hidden space-y-4 rounded-2xl border border-white/10 bg-white/5 p-5 text-sm text-slate-200 lg:block">
              <h2 className="text-xl font-semibold text-white">Cyber-minimal access</h2>
              <p className="text-slate-400">
                Sign in to a glassy dashboard with layered depth, frosted panels, and neon accents that stay calm and clear.
              </p>
              <div className="space-y-2 text-slate-300">
                <div className="flex items-center gap-2 rounded-lg border border-white/10 bg-black/20 px-3 py-2">
                  <span className="h-2 w-2 rounded-full bg-amber-300 shadow-[0_0_0_4px_rgba(246,196,82,0.15)]" />
                  <span>Transparent cards with subtle inner glow.</span>
                </div>
                <div className="flex items-center gap-2 rounded-lg border border-white/10 bg-black/20 px-3 py-2">
                  <span className="h-2 w-2 rounded-full bg-teal-300 shadow-[0_0_0_4px_rgba(94,234,212,0.15)]" />
                  <span>Dark cinematic gradient and blurred ambient light.</span>
                </div>
              </div>
            </div>

            <div className="glass-panel rounded-2xl border border-white/10 bg-white/5 p-5 shadow-[0_18px_60px_-30px_rgba(0,0,0,0.65)]">
              <PasswordReset />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
